import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';

/**
 * Gets search box content (i.e. text, pills, segments) from the store.
 */
export default function getSearchBoxContent(scenarioId: SearchScenarioId) {
    return {
        text: getScenarioStore(scenarioId).searchText,
        pills: getScenarioStore(scenarioId).suggestionPills,
        segments: getScenarioStore(scenarioId).suggestionSegments,
    };
}
